<script lang="ts" setup>
import AppLayout from '@/layouts/AppLayout.vue'
import Confirmation from './components/client/confirm/Confirmation.vue'
</script>

<template>
  <app-layout>
    <router-view />
    <Toast />
    <ConfirmDialog :draggable="false" />
    <Confirmation v-if="$route.path.startsWith('/qr-menu')" group="client" />
  </app-layout>
</template>

<style scoped lang="scss"></style>
